<script>
import moment from "moment"
import "moment/locale/fr"

moment.locale("fr")

    export default {
        methods: {
            formattedDate(date, format = "LL") {
                return moment(date).format(format)
            },
            formattedDateTime(date, format = "Do MMMM YYYY à HH:mm") {
                return moment(date).format(format)
            }
        }
    }
</script>
